module.exports = {
  GOOGLE_MAPS_API_KEY:
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyDf5y_wDMqNcW7slkfPFiX60EUqRu6GMWU",
  INVENSE_API_URL: process.env.REACT_APP_INVENSE_API_URL || "https://api-sls-dev.invense.in",
};
